import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const ApplicantAuthContext = createContext({
  clientAuthInfo: {
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  },
  setClientAuthInfo: () => {},
});
export default ApplicantAuthContext;

export const ApplicantAuthContextProvider = () => {
  const [clientAuthInfo, setClientAuthInfo] = useState({
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  });

  const context = { clientAuthInfo, setClientAuthInfo };
  return (
    <ApplicantAuthContext.Provider value={context}>
      <Outlet />
    </ApplicantAuthContext.Provider>
  );
};
